import React, { useState } from 'react';
import { useGetJobs2Query } from '../store/apiSlice';
import JobSearchFilters from '../components/JobSearchFilter'; // Make sure paths are correct
import JobList from '../views/JobList';          // Make sure paths are correct

const RECORDS_PER_PAGE = 100;

// The base state for our search parameters
const BASE_SEARCH_PARAMS = {
  q: '',
  page: 0,
  sort: 'date',
  filter1: [],
  selectedFilters: [],
};

/**
 * A self-contained component for searching, filtering, and displaying jobs.
 * @param {string} title - The title to display above the search controls.
 * @param {object} initialSearchParams - An object with initial search parameters to merge with the base state.
 */
const JobSearchContainer = ({ title = "Job Search", initialSearchParams = {} }) => {
  
  // The state now intelligently merges the base state with any initial params passed in props
  const [searchParams, setSearchParams] = useState({
    ...BASE_SEARCH_PARAMS,
    ...initialSearchParams,
  });

  // The data fetching hook now lives here
  const {
    data,
    isLoading: isLoadingJobs,
    isFetching: isFetchingJobs,
  } = useGetJobs2Query(searchParams);

  // The handlers now live here
  const handleFilterChange = (newFilters) => {
    setSearchParams((prevParams) => ({
      ...prevParams,
      ...newFilters,
      page: 0, // Reset to the first page on any filter change
    }));
  };

  const handlePageChange = (newPage) => {
    setSearchParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };

  return (
    <div className="bg-slate-50 p-4 sm:p-6 lg:p-8">
      <h2 className="text-2xl font-bold mb-4">{title}</h2>
      
      <JobSearchFilters
        params={searchParams}
        onFilterChange={handleFilterChange}
      />
      
      <JobList
        data={data}
        isLoading={isLoadingJobs || isFetchingJobs}
        page={searchParams.page}
        onPageChange={handlePageChange}
        recordsPerPage={RECORDS_PER_PAGE}
      />
    </div>
  );
};

export default JobSearchContainer;